import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import employeesReducer from "./slices/employees";
import resignationsReducer from "./slices/employees/resignations";
import manavReducer from "./slices/manav";
import dataEntryReducer from "./slices/employees/data-entries";
import systemReducer from "./slices/systemSlice";
import ptReducer from "./slices/employees/participation-transactions";
import zreportsReducer from "./slices/zreports";
import zRaporReducer from "./slices/zRaporSlice";
import cashierPaymentsReducer from "./slices/zreports/cashier-payments";
import coinSettlementsReducer from "./slices/zreports/coin-settlements";
import debtInformationsReducer from "./slices/zreports/debt-informations";
import qrAttendanceLogsReducer from "./slices/employees/qr-attendance-logs";
import {
  saveLS,
  VERI_KEYS,
  ZRAPOR_KEYS,
} from "../utils/storage";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    employees: employeesReducer,
    resignations: resignationsReducer,
    manav: manavReducer,
    dataEntry: dataEntryReducer,
    system: systemReducer,
    pt: ptReducer,
    zRaporDefs: zreportsReducer,
    zRapor: zRaporReducer,
    cashierPayments: cashierPaymentsReducer,
    coinSettlements: coinSettlementsReducer,
    debtInformations: debtInformationsReducer,
    qrAttendanceLogs: qrAttendanceLogsReducer,
  },
});

let prevDataEntry = store.getState().dataEntry;
let prevDefs = store.getState().zRaporDefs;
let prevReports = store.getState().zRapor.reports;
let prevClosure = store.getState().zRapor.dailyClosure;
let prevExtras = store.getState().zRapor.dailyExtras;

store.subscribe(() => {
  const state = store.getState();

  // Veri Girişi
  const next = state.dataEntry;
  if (next !== prevDataEntry) {
    if (next.avans !== prevDataEntry.avans) saveLS(VERI_KEYS.avans, next.avans);
    if (next.mesai !== prevDataEntry.mesai) saveLS(VERI_KEYS.mesai, next.mesai);
    if (next.kasaAcik !== prevDataEntry.kasaAcik)
      saveLS(VERI_KEYS.kasaAcik, next.kasaAcik);
    if (next.kesinti !== prevDataEntry.kesinti)
      saveLS(VERI_KEYS.kesinti, next.kesinti);
    if (next.periods !== prevDataEntry.periods)
      saveLS(VERI_KEYS.periods, next.periods);
    prevDataEntry = next;
  }

  // Z-Rapor reports
  if (state.zRapor.reports !== prevReports) {
    saveLS(ZRAPOR_KEYS.reports, state.zRapor.reports);
    prevReports = state.zRapor.reports;
  }
  if (state.zRapor.dailyClosure !== prevClosure) {
    saveLS(ZRAPOR_KEYS.dailyClosure, state.zRapor.dailyClosure);
    prevClosure = state.zRapor.dailyClosure;
  }
  if (state.zRapor.dailyExtras !== prevExtras) {
    saveLS(ZRAPOR_KEYS.dailyExtras, state.zRapor.dailyExtras);
    prevExtras = state.zRapor.dailyExtras;
  }
});
